<template>
  <div class="hcl-block-content-html" v-bind="attributesMeta(props.definition.meta)">
    <div v-if="props.definition.content"
      v-for="(content, index) in props.definition.content"
      :key="index"
      v-html="content.html"
    >
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMeta } from '@/composables/meta'

import { DefinitionBlockContentHtml } from '@/components/types'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionBlockContentHtml
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const { attributesMeta } = useMeta()
</script>
